import loadable from '@loadable/component';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetData, WidgetTypeEnum } from '../../models/Index';
import useStyles from './styles';
import not_configured_icon from '../../assets/img/settings--tools.svg';
import CustomDataTable from '../widget-types/custom-data-table/CustomDataTable';

export const AcdWallboardBottom = loadable(() => import('../widget-types/acd-wallboard-bottom/AcdWallboardBottom'));
export const AcdWallboardRight = loadable(() => import('../widget-types/acd-wallboard-right/AcdWallboardRight'));
export const Clock = loadable(() => import('../widget-types/clock/Clock'));
export const FreeText = loadable(() => import('../widget-types/free-text/FreeText'));
export const Iframe = loadable(() => import('../widget-types/iframe/Iframe'));
export const ObmCampaignOverview = loadable(() => import('../widget-types/obm-campaign-overview/ObmCampaignOverview'));
export const ObmUserRanking = loadable(() => import('../widget-types/obm-user-ranking/ObmUserRanking'));
export const Picture = loadable(() => import('../widget-types/picture/Picture'));
export const RssFeed = loadable(() => import('../widget-types/rss-feed/RssFeed'));
export const SingleValue = loadable(() => import('../widget-types/single-value/SingleValue'));
export const SupersetDashboard = loadable(() => import('../../pages/dashboard/Dashboard'));
export const Video = loadable(() => import('../widget-types/video/Video'));
export const Weather = loadable(() => import('../widget-types/weather/Weather'));
export const LineChart = loadable(() => import('../widget-types/line-chart/LineChart'));
export const BarChart = loadable(() => import('../widget-types/bar-chart/BarChart'));
export const DataTable = loadable(() => import('../widget-types/custom-data-table/CustomDataTable'));

type Props = {
    data: WidgetData;
};

function WidgetContent(props: Props) {
    const classes = useStyles();
    const [widgetData, setWidgetData] = useState({} as WidgetData);
    const [divId, setDivId] = useState('widget-content-height-1');
    const [t] = useTranslation();

    useEffect(() => {
        if (props.data) {
            setDivId(`widget-content-height-${props.data.key}`);
            setWidgetData((prevData) => ({ ...prevData, ...props.data }));
        }
    }, [props.data]);

    useEffect(() => {
        // sets height of widget content
        let widgetHeight = document.getElementById(divId || '');
        const height =
            widgetData?.title?.length > 0 &&
            ![WidgetTypeEnum.IFRAME, WidgetTypeEnum.PICTURE].includes(widgetData?.type) &&
            !widgetData?.isUsedAsHeadline
                ? 'calc(100% - 24px)'
                : '100%';
        widgetHeight.style.height = height;
    }, [divId, widgetData, widgetData?.title]);

    const mapping = {
        DATA_TABLE: CustomDataTable,
        ACD_WALLBOARD_BOTTOM: AcdWallboardBottom,
        ACD_WALLBOARD_RIGHT: AcdWallboardRight,
        CLOCK: Clock,
        FREE_TEXT: FreeText,
        IFRAME: Iframe,
        OBM_CAMPAIGN_OVERVIEW: ObmCampaignOverview,
        OBM_USER_RANKING: ObmUserRanking,
        PICTURE: Picture,
        RSS_FEED: RssFeed,
        SINGLE_VALUE: SingleValue,
        SUPERSET_DASHBOARD: SupersetDashboard,
        VIDEO: Video,
        WEATHER: Weather,
        LINE_CHART: LineChart,
        BAR_CHART: BarChart,
    };

    let CardType = mapping[widgetData?.type];
    if (typeof CardType === 'undefined') {
        return (
            <>
                <div
                    id={divId}
                    className={classes.notConfigured}
                    style={{
                        color: widgetData?.fontColor,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}
                >
                    <div className={classes.notConfiguredIcon}>
                        <img src={not_configured_icon} alt="Not configured" />
                    </div>
                    {t('WIDGET_EDITOR.NOT_CONFIGURED_TEXT')}
                </div>
            </>
        );
    }

    return (
        <>
            {widgetData && (
                <div
                    id={divId}
                    style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: widgetData?.type === WidgetTypeEnum.DATA_TABLE ? 'space-between' : 'center',
                        overflow: widgetData?.type === WidgetTypeEnum.FREE_TEXT ? 'auto' : 'unset',
                        overflowY: widgetData?.isUsedAsHeadline ? 'hidden' : 'unset',
                        userSelect: 'none',
                        pointerEvents: widgetData?.type === WidgetTypeEnum.PICTURE ? 'none' : 'auto',
                    }}
                >
                    <CardType id={divId} data={widgetData} />
                </div>
            )}
        </>
    );
}

export default WidgetContent;
